export default {
    setPreorders(state, data) {
        state.preorders = data
    }
}
